
export default {
    enable(state) {
        state.isLoaded = true;
    }
}
